import type { SliderSchemaType } from '@vedalib/editor/lib/brand'
import cn from 'classnames'
import { useContext } from 'use-context-selector'

import type { ElementStyleCss } from 'services/Branding/types'
import { DeviceMode } from 'services/Store/Project/enums'
import { testProps } from 'utils/test/qaData'

import SliderContext from '../SliderContext'
import Left from '../assets/left.svg?react'
import Right from '../assets/right.svg?react'
import { ArrowPosition } from '../sliderTypes'
import ArrowStyled from '../styled/ArrowStyled'
import * as s from './Arrows.module.scss'
import { getMargins } from './getMargins'

interface IArrowsProps {
  children?: React.ReactNode
  styles: ElementStyleCss<SliderSchemaType>
  isV2?: boolean
}

const Arrows: React.FC<IArrowsProps> = ({ children, styles, isV2 }) => {
  const { leftArrowNoLoop, rightArrowNoLoop, mode, slideIndex, prevSlide, nextSlide } =
    useContext(SliderContext)
  const isMobile = mode.deviceMode === DeviceMode.mobile

  const margins = getMargins(String(styles.indents.margin))
  const isProgressPosition = styles.icons.sliderPosition === ArrowPosition.progress

  const handleLeftArrow = () => {
    if (!leftArrowNoLoop) {
      prevSlide()
    }
  }

  const handleRightArrow = () => {
    if (!rightArrowNoLoop) {
      nextSlide()
    }
  }

  return (
    <div
      className={cn(s.arrows, { [s.isV2]: isV2 })}
      style={{
        marginTop: styles.icons.sliderPosition === ArrowPosition.slide ? undefined : margins.bottom,
        paddingBottom: isProgressPosition ? (isMobile ? 4 : 8) : undefined,
      }}
    >
      <ArrowStyled
        {...testProps({
          el: 'sliderElNav',
          name: 'left',
          activeIndex: slideIndex,
          disabled: leftArrowNoLoop,
        })}
        $disabled={leftArrowNoLoop}
        $styles={styles}
        aria-disabled={leftArrowNoLoop}
        aria-label='Previous slide'
        onClick={handleLeftArrow}
        style={{ marginRight: margins.right }}
      >
        {styles.leftArrow.backgroundImage ? (
          <div className={s.icon} style={styles.leftArrow} />
        ) : (
          <Left aria-hidden='true' />
        )}
      </ArrowStyled>
      {children}
      <ArrowStyled
        {...testProps({
          el: 'sliderElNav',
          name: 'right',
          activeIndex: slideIndex,
          disabled: rightArrowNoLoop,
        })}
        $disabled={rightArrowNoLoop}
        $styles={styles}
        aria-disabled={rightArrowNoLoop}
        aria-label='Next slide'
        onClick={handleRightArrow}
        style={{ marginLeft: margins.left }}
      >
        {styles.rightArrow.backgroundImage ? (
          <div className={s.icon} style={styles.rightArrow} />
        ) : (
          <Right aria-hidden='true' />
        )}
      </ArrowStyled>
    </div>
  )
}

export default Arrows
